export default __webpack_public_path__ + "static/media/meat_alone.c33115e7.png";